<template>
  <div class="entry-info-box">
    <div class="title">
      <div class="title-left">
        <img src="https://images.snsports.cn/Fszt7IivQB9Yz_leqZnMJcSgyL_z" alt="球队报名表" class="title-logo" />
      </div>
      <div class="title-right" @click="showAction = true">···</div>
    </div>
    <div class="match-info">
      <img :src="imageView(match.icon)" alt="">
      <div class="info">
        <div class="name">{{ match.unionMatchName }}</div>
        <div class="group">
          <span class="group-label">组别</span>
          <span class="group-value">{{ match.group }}</span>
        </div>
      </div>
    </div>
    <!-- 卡片入口：参赛队伍(logo+名称+查看详情) / 队员名单 / 工作人员 -->
    <div class="card-section">
      <div class="card card-full card-team" @click="goTeamInfo">
        <div class="card-team-left">
          <span class="card-title">{{ isGroupComboUnit ? '报名资料' : '参赛队伍' }}</span>
          <div class="team-left">
            <div class="team-logo" v-if="team.badge">
              <img :src="imageView(team.badge)" alt="" />
            </div>
            <span class="team-name">{{ team.name || '-' }}</span>
          </div>
        </div>
        <div class="card-team-action">
          <span class="card-link">查看详情</span>
        </div>
      </div>
      <div class="card-row">
        <div v-if="!isGroupComboUnit" class="card card-half card-player" @click="goPlayerList">
          <div class="card-title-row">
            <span class="card-title">队员名单</span>
            <span class="card-link">查看</span>
          </div>
          <div class="card-desc"><span class="num">已入队{{ players.length }}</span>/{{ match.teamMemberLimitCount || 0 }} 人</div>
          <div v-if="showPlayerSelfFill" class="btn-player-self-fill" @click.stop="weChatShare">
            <img src="@/assets/images/wx-round-icon.png" alt="" />
            <span style="margin-left: 3px;">队员自填</span>
          </div>
        </div>
        <div class="card card-half card-officer" v-if="officer" @click="goOfficerList">
          <div class="card-title-row">
            <span class="card-title">工作人员</span>
            <span class="card-link">查看</span>
          </div>
          <div class="card-desc"><span class="num">已加入{{ officers.length }}</span> / {{ match.maxOffice || 0 }} 人</div>
        </div>
        <!-- 参赛费用：仅队付（2/3）展示；队员独立付费（1）由队员在 entry-info-player 等页支付 -->
        <div
          class="card card-half card-fee"
          v-if="match && match.isOpenCharge === 1 && (match.feeMethod === 2 || match.feeMethod === 3)"
          @click="goFeePayment"
        >
          <div class="card-title-row">
            <span class="card-title">参赛费用</span>
            <span class="card-link">{{ getPaymentStatus(team.orderStatus) }}</span>
          </div>
          <div class="card-desc">
            报名费：
            <span class="price">¥{{ feeAmountText }}</span>
          </div>
        </div>
        <!-- 协议/承诺书：isUseAgreement 开启时展示（领队侧，队员另页） -->
        <EntryMiniStatCard
          v-if="showAgreementCard"
          layout="leader"
          class="card card-half card-agreement"
          title="协议/承诺书"
          :status-done="teamAgreementStatusDone"
          :count-line-done="teamAgreementCountLineDone"
          desc-class="agreement-count"
          :show-time-row="showAgreementTimeRow"
          :time-text="agreementBottomText"
          @click="onAgreementCardClick"
        >
          <template #middle>已确认 {{ teamAgreementDone }}/{{ teamAgreementTotal }} 份</template>
        </EntryMiniStatCard>
      </div>
    </div>
    <EntryWxSubscribeRemind
      :visible="showWxSubscribeRemind"
      @click="goNotifySetting"
    />
    <div
      v-if="showGoMatchHomeBtn"
      type="button"
      class="go-match-home-btn"
      @click="goUnionMatchHome"
    >
      去赛事首页·关注赛程
  </div>
    <div class="footer-box">
      <div class="footer">
        <div class="left">
          <div>
            <span v-if="team.isSubmit === 0">未提交</span>
            <span v-else-if="team.auditStatus === 0 || team.auditStatus === 1" style="color: #909399">待确认</span>
            <span v-else-if="team.auditStatus === 3" style="color: #409EFF">已锁定</span>
            <span v-else-if="team.auditStatus === 2" style="color: #409EFF">已确认</span>
            <span v-else-if="team.auditStatus === -1" style="color: #F56C6C">已退回</span>
          </div>
        </div>
        <div
          ref="submitAuditGuideAnchor"
          class="right"
          v-if="showSubmitAuditButton"
          :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }"
          @click="updateBMMatchTeam()"
        >提交审核</div>
      </div>
    </div>

    <van-action-sheet
      class="entry-info-action-sheet-popup"
      v-model="showAction"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      :safe-area-inset-bottom="true"
      @cancel="showAction = false"
      @select="handleAction"
    />
    <ShareLayer :shareShow="shareShow" @close="shareShow = false"></ShareLayer>
    <EntrySubmitAuditGuide
      :show="showSubmitAuditGuide"
      :hole-rect="submitAuditGuideRect"
      :viewport="submitAuditGuideViewport"
      :jetlympic="jetlympic"
      @dismiss="dismissSubmitAuditGuide"
    />
  </div>
</template>

<script>
import {
  getBMMatchTeamSignup,
  getCrmAccountWXSubscribeConfig,
  checkBMMatchBeforeSubmit,
  submitBMMatchTeam,
  bangsaishiCreateTeamSignupOrder,
  cancelBMMatchTeam
} from '@/api/match'
import { getThemeAccountId } from '@/libs/cookie-storage'
import { QNImageUtil, isWeChatMiniApp } from '@/utils'
import { orderStatusOptions } from '@/config'
import {
  parseAgreementDate,
  formatAgreementMd,
  phaseFromBeginEnd,
  scheduleBottomText
} from '@/utils/entry-agreement-dates'
import { goWxSubscribeNotify } from '@/utils/wx-subscribe-notify'
import Vue from 'vue'
import { ActionSheet, Dialog, Toast } from 'vant'
Vue.use(ActionSheet).use(Dialog).use(Toast)
import ShareLayer from '@/components/ShareLayer'
import EntryWxSubscribeRemind from './EntryWxSubscribeRemind.vue'
import EntryMiniStatCard from './EntryMiniStatCard.vue'
import EntrySubmitAuditGuide from './EntrySubmitAuditGuide.vue'
import wx from 'weixin-js-sdk'
import { AppType } from '@/constants/appType'
export default {
  components: { ShareLayer, EntryWxSubscribeRemind, EntryMiniStatCard, EntrySubmitAuditGuide },
  data() {
    return {
      unionMatchId: '',
      matchId: '',
      teamId: '',
      team:{},
      match: {},
      players: [],
      officers: [],
      showAction: false,
      actions: [],
      officer: false,
      shareShow: false,
      jetlympic: false,
      /** 进入页仅弹一次：未完成协议且在可完成时段内 */
      incompleteRemindShown: false,
      /** 接口 GetBMMatchWxSubscribeConfig：isWxSubscribe、configList */
      wxSubscribe: {
        isWxSubscribe: 0,
        configList: []
      },
      showSubmitAuditGuide: false,
      submitAuditGuideRect: null,
      submitAuditGuideViewport: { w: 0, h: 0 },
      submitAuditGuideRetry: 0,
      submitAuditGuideDialogWait: 0
    };
  },
  computed: {
    /** 是否注册报名类型（与 member-list 一致：注册类型不显示队员自填） */
    isRegisterType() {
      return this.match && this.match.publicSignUp === 2;
    },
    /** 组合报名（多人）：unitType 0队 1人 2多人 — 与 project-list / entry-info-more 一致 */
    isGroupComboUnit() {
      const u = this.match && this.match.unitType
      return u === 2 || u === '2'
    },
    /** 是否显示队员自填按钮：非注册类型且允许队员自填时显示，与 member-list 邀请成员条件一致 */
    showPlayerSelfFill() {
      if (!this.team || !this.match) return false;
      const canEdit = this.team.isSubmit === 0 || this.team.auditStatus === -1;
      if (!canEdit) return false;
      if (this.isRegisterType) return false;
      return this.match.teamLeaderAddPlayerOnly !== 1;
    },
    /** 报名费显示文本：xx.xx/队 或 xx.xx/人 */
    feeAmountText() {
      if (!this.match || !this.match.feeAmount) return '0.00'
      const amount = (this.match.feeAmount / 100).toFixed(2)
      const unit = this.match.feeMethod === 2 ? '队' : '人'
      return `${amount}/${unit}`
    },
    /**
     * 领队报名总览：仅当开启协议且配置了领队侧份数时展示（与 member-list 队员行仅看 playerAgreements 同理；
     * 若只配了队员协议、未配领队协议，teamAgreementCount 为 0，不应出现 0/0 卡）
     */
    showAgreementCard() {
      const m = this.match
      if (!m || (m.isUseAgreement !== 1 && m.isUseAgreement !== '1')) return false
      return this.teamAgreementTotal > 0
    },
    agreementBeginTs() {
      return parseAgreementDate(this.match && this.match.agreementBeginDate)
    },
    agreementEndTs() {
      return parseAgreementDate(this.match && this.match.agreementEndDate)
    },
    agreementPhase() {
      return phaseFromBeginEnd(this.agreementBeginTs, this.agreementEndTs)
    },
    teamAgreementTotal() {
      const n = Number(this.match && this.match.teamAgreementCount)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    teamAgreementDone() {
      const n = Number(this.team && this.team.agreementConfirmedCount)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    /** 顶部右侧「已完成」：进行中/已截止 且 领队协议已全部确认；开启前或未配置数量时未完成 */
    teamAgreementStatusDone() {
      if (this.agreementPhase === 'before') return false
      if (this.teamAgreementTotal <= 0) return false
      return this.teamAgreementDone >= this.teamAgreementTotal
    },
    /** 「已确认 x/y 份」绿色：非开启前且已全部确认 */
    teamAgreementCountLineDone() {
      if (this.agreementPhase === 'before') return false
      if (this.teamAgreementTotal <= 0) return false
      return this.teamAgreementDone >= this.teamAgreementTotal
    },
    agreementBottomText() {
      return scheduleBottomText(
        this.agreementPhase,
        this.agreementBeginTs,
        this.agreementEndTs,
        formatAgreementMd
      )
    },
    /** 无时间区间（如提交审核前先确认）时不展示时钟行，避免出现 icon + — */
    showAgreementTimeRow() {
      return this.agreementBottomText !== '—'
    },
    /** GetBMMatchTeamSignup.match.submitNeedAgreement：提交审核前是否强制校验领队协议已全部确认 */
    submitNeedAgreement() {
      const m = this.match
      if (!m) return false
      return m.submitNeedAgreement === 1 || m.submitNeedAgreement === '1'
    },
    /** isWxSubscribe === 1 时展示消息提醒入口 */
    showWxSubscribeRemind() {
      return Number(this.wxSubscribe.isWxSubscribe) === 1
    },
    showGoMatchHomeBtn() {
      return !!(this.unionMatchId || (this.match && this.match.unionMatchId))
    },
    /**
     * 底部「提交审核」与引导蒙层锚点：兼容 isSubmit 为 '0'/未返回的新建球队；已确认/已锁定不展示。
     */
    showSubmitAuditButton() {
      const t = this.team
      if (!t) return false
      if (Number(t.auditStatus) === -1) return true
      const a = Number(t.auditStatus)
      if (a === 2 || a === 3) return false
      if (Number(t.isSubmit) === 1 || t.isSubmit === '1') return false
      return true
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onSubmitAuditGuideResize)
      window.addEventListener('orientationchange', this.onSubmitAuditGuideResize)
    }
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    this.unionMatchId = this.$route.query.unionMatchId
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    this.getBMMatchTeamSignup()
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onSubmitAuditGuideResize)
      window.removeEventListener('orientationchange', this.onSubmitAuditGuideResize)
    }
  },
  methods: {
    /** GetCrmAccountWXSubscribeConfig：仅 query accountId（机构维度） */
    fetchWxSubscribeConfig() {
      const accountId =
        (this.match && this.match.accountId) ||
        this.$route.query.accountId ||
        getThemeAccountId()
      if (accountId === '' || accountId == null) return
      getCrmAccountWXSubscribeConfig({ accountId, scene: 'match_team_signup' }).then(res => {
        if (!res) return
        const data = res.data != null ? res.data : res
        this.wxSubscribe = {
          isWxSubscribe: data.isWxSubscribe != null ? data.isWxSubscribe : 0,
          configList: Array.isArray(data.configList) ? data.configList : []
        }
      })
    },
    async goNotifySetting() {
      await goWxSubscribeNotify({
        wxSubscribe: this.wxSubscribe,
        matchId: this.matchId,
        teamId: this.teamId
      })
    },
    goUnionMatchHome() {
      const id = this.unionMatchId || (this.match && this.match.unionMatchId)
      if (!id) {
        Toast('缺少赛事信息')
        return
      }
      // 
      this.$router.push({ path: `/new-match-detail/${id}/home` })
    },
    /**
     * submitNeedAgreement 开启时：须已过了协议开启时间，且配置了协议份数时须全部确认（与卡片「已确认 x/y 份」一致）。
     * 未配置协议份数（y=0）视为无需签署，不拦截。
     */
    canSubmitWithAgreementRule() {
      if (!this.submitNeedAgreement) return true
      if (this.agreementPhase === 'before') {
        Dialog.alert({
          message: '协议确认尚未开启，暂不可提交审核',
          confirmButtonText: '确定'
        })
        return false
      }
      if (this.teamAgreementTotal <= 0) return true
      if (this.teamAgreementDone < this.teamAgreementTotal) {
        Dialog.alert({
          message: '请先确认全部协议后再提交审核',
          confirmButtonText: '确定'
        })
        return false
      }
      return true
    },
    onAgreementCardClick() {
      if (!this.showAgreementCard) return
      if (this.agreementPhase === 'before') {
        Toast('协议确认尚未开启')
        return
      }
      this.$router.push({
        path: '/entry-page/agreement-list',
        query: {
          type: 'leader',
          teamId: this.teamId,
          matchId: this.matchId,
          unionMatchId: this.unionMatchId
        }
      })
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.matchId,
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          this.team = data.team
          this.match = data.match
          this.players = data.players
          this.officers = data.officers
          if (this.match.teamSignupFields.indexOf('officer') !== -1) {
            this.officer = true
          }
          if (this.team.isSubmit === 0) { // 未提交时可以做的操作
            // this.actions = [{ name: '编辑队伍信息' }]
            if(this.match.teamLeaderTransferOpen === 1) {
              this.actions.push({ name: '移交领队' })
              this.actions.push({ name: '取消报名',color: '#ee0a24' })
            }
          } else if ((this.team.auditStatus === 0 || this.team.auditStatus === 1 || this.team.auditStatus === 2) && this.match.teamLeaderTransferOpen === 1) {  // 提交待审核、已确认、已锁定
            this.actions = [{ name: '移交领队' }]
          } else if (this.team.auditStatus === -1) { // 已退回
            if(this.match.teamLeaderTransferOpen === 1) {
              this.actions = [{ name: '移交领队' }, { name: '取消报名',color: '#ee0a24' }]
            } else {
              this.actions = [{ name: '取消报名',color: '#ee0a24' }]
            }
          }
          this.fetchWxSubscribeConfig()
          this.$nextTick(() => this.maybeShowIncompleteRemindTeam())
          this.scheduleTryShowSubmitAuditGuide()
        }
      })
    },
    updateSubmitAuditViewport() {
      if (typeof window === 'undefined') return
      this.submitAuditGuideViewport = { w: window.innerWidth, h: window.innerHeight }
    },
    measureSubmitAuditAnchor() {
      const el = this.$refs.submitAuditGuideAnchor
      if (!el) return null
      const rect = el.getBoundingClientRect()
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      }
    },
    scheduleTryShowSubmitAuditGuide() {
      const delays = [500, 1200, 2400, 3800]
      delays.forEach((ms) => {
        setTimeout(() => {
          if (this.showSubmitAuditGuide) return
          this.tryShowSubmitAuditGuide()
        }, ms)
      })
    },
    submitAuditGuideStorageKey() {
      return `signup_sheet_submit_audit_entry_${this.matchId || ''}_${this.teamId || this.team.id || ''}`
    },
    tryShowSubmitAuditGuide() {
      if (!this.team || !this.match) return
      if (this.showSubmitAuditGuide) return
      if (!this.showSubmitAuditButton) return
      if (!(this.teamId || (this.team && this.team.id))) return
      try {
        if (localStorage.getItem(this.submitAuditGuideStorageKey()) === '1') return
      } catch (e) {
        void e
      }
      if (typeof document !== 'undefined' && document.querySelector('.van-dialog')) {
        this.submitAuditGuideDialogWait += 1
        if (this.submitAuditGuideDialogWait <= 15) {
          setTimeout(() => this.tryShowSubmitAuditGuide(), 400)
        }
        return
      }
      this.submitAuditGuideDialogWait = 0
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.updateSubmitAuditViewport()
          const r = this.measureSubmitAuditAnchor()
          if (!r || r.width < 4 || r.height < 4) {
            this.submitAuditGuideRetry += 1
            if (this.submitAuditGuideRetry <= 24) {
              setTimeout(() => this.tryShowSubmitAuditGuide(), 400)
            } else {
              this.submitAuditGuideRetry = 0
            }
            return
          }
          this.submitAuditGuideRetry = 0
          this.submitAuditGuideRect = r
          this.showSubmitAuditGuide = true
        })
      })
    },
    dismissSubmitAuditGuide() {
      try {
        localStorage.setItem(this.submitAuditGuideStorageKey(), '1')
      } catch (e) {
        void e
      }
      this.showSubmitAuditGuide = false
      this.submitAuditGuideRect = null
    },
    onSubmitAuditGuideResize() {
      if (!this.showSubmitAuditGuide) return
      this.updateSubmitAuditViewport()
      const r = this.measureSubmitAuditAnchor()
      if (r) this.submitAuditGuideRect = r
    },
    /** 未完成领队协议且当前处于可完成时段（进行中）时提醒一次 */
    maybeShowIncompleteRemindTeam() {
      if (this.incompleteRemindShown) return
      if (!this.showAgreementCard || this.teamAgreementTotal <= 0) return
      if (this.teamAgreementDone >= this.teamAgreementTotal) return
      if (this.agreementPhase !== 'during') return
      this.incompleteRemindShown = true
      const msg = this.agreementEndTs
        ? `协议确认和问卷填写通道已开启，请在 ${formatAgreementMd(this.agreementEndTs)} 前完成相关操作`
        : '协议确认和问卷填写通道已开启，请在提交审核前完成相关操作'
      Dialog.alert({ message: msg, confirmButtonText: '确定' })
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getPaymentStatus(value) {
      if (this.match.isOpenCharge !== 1) return ''
      if (this.match.feeMethod === 0) return ''
      const order = orderStatusOptions.find(o => o.value == value)
      if (!order) return '待支付'
      if (order.label === '已取消') return ''
      return order.label
    },
    /**
     * 参赛费用卡片（仅队付 feeMethod 2/3）：有 team.orderId 则去支付页；否则校验后创建队订单再跳转。
     * 队员独立付费（feeMethod 1）不在此页展示，由 entry-info-player / person-info 等处理。
     */
    goFeePayment() {
      if (!this.match || this.match.isOpenCharge !== 1) return
      if (this.match.feeMethod !== 2 && this.match.feeMethod !== 3) return
      if (!this.teamId) {
        Toast.fail('缺少队伍信息')
        return
      }
      getBMMatchTeamSignup({ matchId: this.matchId, teamId: this.teamId }).then(res => {
        if (!res || !res.data) return
        const team = res.data.team || {}
        // const match = res.data.match || this.match

        if (team.orderId) {
          this.$router.push(
            `/entry-page/payment?orderId=${team.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.matchId}&teamId=${this.teamId}`
          )
          return
        }

        checkBMMatchBeforeSubmit({ teamId: this.teamId, matchId: this.matchId }).then(ok => {
          if (!ok) return
          bangsaishiCreateTeamSignupOrder({ matchId: this.matchId, teamId: this.teamId }).then(r => {
            if (r && r.data && r.data.orderId) {
              this.$router.push(
                `/entry-page/payment?orderId=${r.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.matchId}&teamId=${this.teamId}`
              )
            }
          })
        })
      })
    },
    updateBMMatchTeam() {
      if (!this.canSubmitWithAgreementRule()) return
      if (this.match.isOpenCharge === 1 && (this.match.feeMethod === 2 || this.match.feeMethod === 3) && this.team.orderStatus != 1 && this.team.orderStatus != 2) {
        /**
         * 先校验
         * TODO
         */
        const params = {
          teamId: this.teamId,
          matchId: this.matchId
        }
        checkBMMatchBeforeSubmit(params).then(res => {
          if (res) {
            Dialog.confirm({
              title: '尚未支付',
              message: '尚未支付，请前往支付费用',
            }).then(() => {
              const params = {
                matchId: this.matchId,
                teamId: this.teamId
              }
              bangsaishiCreateTeamSignupOrder(params).then(res => {
                if (res) {
                  this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.matchId}&teamId=${this.teamId}`)
                }
              })
            })
          }
        })
      } else {
        checkBMMatchBeforeSubmit({
          teamId: this.teamId,
          matchId: this.matchId
        }).then(res => {
          if (res) {
            const params = {
              teamId: this.teamId,
              matchId: this.matchId
            }
            submitBMMatchTeam(params).then(res => {
              if (res) {
                Dialog.alert({
                  message: '报名提交成功',
                  confirmButtonText: '确定'
                }).then(() => {
                  this.getBMMatchTeamSignup()
                })
                // this.$router.back()
              }
            })
          }
        })
      }
    },
    handleAction(item) {
      if (item.name === '编辑队伍信息') {
        this.$router.push(`/entry-page/entry-info-team?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}`)
      } else if (item.name === '移交领队') { 
        this.goTransfer()
      } else if (item.name === '取消报名') {
        this.cancelBMMatchTeam()
      }
    },
    goTransfer() {
      this.$router.push(`/entry-page/transfer-captain?matchId=${this.matchId}&teamId=${this.teamId}`)
    },
    goTeamInfo() {
      if (this.isGroupComboUnit) {
        this.$router.push(
          `/entry-page/entry-info-more?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}`
        )
        return
      }
      this.$router.push(`/entry-page/entry-info-team-detail?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}`)
    },
    goPlayerList() {
      this.$router.push(`/entry-page/member-list?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&type=player`)
    },
    goOfficerList() {
      this.$router.push(`/entry-page/member-list?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&type=officer`)
    },
    cancelBMMatchTeam() {
      if ((this.match.isOpenCharge === 1 && this.match.feeMethod === 1 && this.match.isChargeCount > 0) || (this.match.isOpenCharge === 1 && (this.match.feeMethod === 2 || this.match.feeMethod === 3) && (this.match.orderStatus === 1 || this.match.orderStatus === 2))) {
        Dialog.alert({
          title: '取消失败',
          message: '已有队员支付报名费用，取消报名请联系组委会',
        })
        return
      }
      Dialog.confirm({
        title: '是否取消报名',
        message: '取消后，数据将丢失',
      }).then(() => {
        const params = {
          matchId: this.matchId,
          teamId: this.teamId
        }
        cancelBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('取消成功')
            this.$router.back()
          }
        })
      })
    },
    async weChatShare() {
      // 先判断是否在微信环境
      if (!AppType.isInWeChat()) {
        Toast.fail('请在微信环境下打开')
        return
      }
      
      // 判断是否为微信小程序环境
      const isMiniApp = await isWeChatMiniApp()
      
      if (isMiniApp) {
        // 微信小程序环境
        wx.miniProgram.navigateTo({
          url: `/pages/share/index?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}&teamId=${this.teamId}`
        })
      } else {
        // 微信浏览器环境
        this.shareShow = true
        const shareObj = {
          title: this.team.name + '邀请您加入',
          abstract: this.team.name + '邀请您参加' + (this.match.unionMatchName || '') + '/' + (this.match.group || this.match.matchGroupName || '') + '的比赛',
          link: process.env.VUE_APP_BM_MATCH + '#/entry-page/wx-invite-landing?unionMatchId=' + this.unionMatchId + '&matchId=' + this.matchId + '&teamId=' + this.teamId,
          image: this.match.icon ? QNImageUtil.imageView(this.match.icon) : ''
        }
        this.wxShare(shareObj)
      }
    },
  },
};
</script>

<style scoped lang="scss">
.entry-info-box{
  background: var(--bg2);
  padding: 0 14px;
  min-height: 100vh;
  padding-top: 12px;
  padding-bottom: 100px;
  box-sizing: border-box;
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left{
      display: flex;
      align-items: center;
      .title-logo{
        width: 95px;
        height: 22px;
        display: block;
      }
    }
    .title-right{
      border-radius: 50%;
      background-color: var(--bg1);
      width: 27px;
      height: 27px;
      text-align: center;
      line-height: 27px;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .match-info {
    display: flex;
    align-items: center;
    margin-top: 4px;
    img{
      width: 46px;
      height: 46px;
      border-radius: 50%;
      margin-right: 7px;
    }
    .info{
      .name{
        font-size: 15px;
        font-weight: bold;
      }
      .group{
        display: inline-block;
        border-radius: 70px;
        background-color: var(--bg1);
        overflow: hidden;
        font-size: 0px;
        margin-top: 4px;
        .group-label{
          background-color: #337ECC;
          color: #fff;
          padding: 3px 8px;
          font-size: 12px;
        }
        .group-value{
          font-size: 12px;
          padding: 3px 10px;
        }
      }
    }
  }
  // padding: 12px;
  .team-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background-color: #fff;
    height: 52px;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    img{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 0.75px solid #EEEEEE;
      margin-right: 8px;
    }
    .name{
      font-size: 15px;
      color: #1D2129;
      display: flex;
      align-items: center;
    }
    .status{
      width: 72px;
      height: 22px;
      border-radius: 75px;
      text-align: center;
      line-height: 22px;
      font-size: 13px;
      font-weight: 500;
      color: #FFF;
      background: #DBEBFA;
    }
  }
  .match{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 16px;
    background-color: #fff;
    font-size: 12px;
    color: #999;
    .more{
      color: #30D55B;
    }
  }
  .card-section{
    padding: 0;
    margin-top: 12px;
    .card{
      background: var(--bg1);
      border-radius: 8px;
      padding: 14px 16px;
      // margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-title{
        font-size: 15px;
        color: #1D2129;
        font-weight: 500;
      }
      .card-link{
        font-size: 14px;
        color: #4AA2F7;
      }
    }
    .card-team{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .card-title{
        margin-bottom: 10px;
      }
      .card-team-left{
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .team-left{
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
      }
      .team-logo{
        width: 25px;
        height: 25px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        background: #e8e8e8;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .team-name{
        flex: 1;
        min-width: 0;
        font-size: 15px;
        font-weight: 500;
        color: #1d2129;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .card-team-action{
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 16px;
      }
      .card-link{
        font-size: 14px;
        color: #1989fa;
      }
    }
    .card-row{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 12px;
      margin-top: 12px;
    }
    .card-half{
      width: 167px;
      height: 105px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      .card-half-left{
        flex: 1;
        min-width: 0;
      }
      .card-desc{
        font-size: 13px;
        color: #666;
        margin-top: 12px;
        .num{
          color: #30D55B;
        }
      }
      .card-link{
        flex-shrink: 0;
        margin-left: 8px;
      }
    }
    .card-title-row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .card-title{
        margin-bottom: 0;
      }
      .card-link{
        flex-shrink: 0;
        margin-left: 8px;
        font-size: 14px;
        color: #1989fa;
      }
    }
    .card-player,
    .card-officer,
    .card-fee{
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      .card-desc{
        margin-top: 12px;
      }
    }
    .card-fee {
      cursor: pointer;
    }
    .card-agreement{
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
    }
    .card-player .btn-player-self-fill{
      display: flex;
      align-items: center;
      height: 16px;
      line-height: 16px;
      background: #F5FCEF;
      border-radius: 70px;
      width: 70px;
      font-size: 11px;
      color: #10BC00;
      margin-top: 12px;
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
  .go-match-home-btn {
     font-size: 14px;
    font-weight: 400;
    color: #1d2129;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    margin-top: 24px;
  }
  .footer-box{
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    // box-sizing: border-box;
    height: 88px;
    background-color: #fff;
    // padding-bottom: 12px;
    box-shadow: 0px -2px 10px 0px rgba(0,0,0,0.05);
    .title{
      background: #FFF5EB;
      font-size: 13px;
      color: #3D3D3D;
      padding-left: 12px;
      height: 24px;
      line-height: 24px;
    }
  }
  .footer{
    padding: 6px 12px 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.footer-submit-only{
      justify-content: flex-end;
      .left{
        display: none;
      }
    }
    .left{
      font-size: 14px;
      color: #3D3D3D;
      display: flex;
      width: 76px;
      height: 36px;
      border-radius: 5px;
      background-color: #F4F4F5;
      text-align: center;
      justify-content: center;
      align-items: center;
      div{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      img{
        width: 27px;
        height: 27px;
        border-radius: 50%;
        margin-bottom: 6px;
        margin-left: 12px;
      }
    }
    .right{
      width: 117px;
      height: 45px;
      border-radius: 69px;
      background: #509DEA;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 45px;
    }
  }
}
</style>

<style lang="scss">
/* ActionSheet 常挂到 body；在安全区基础上再加底部留白，避免「取消」贴齐 iOS 横条 */
.entry-info-action-sheet-popup.van-popup--bottom {
  box-sizing: border-box;
  padding-bottom: 14px;
}
</style>
